enum Message {
    mins = 'mins',
    checktrue = 'checktrue',
    checkfalse = 'checkfalse',
    checkindetermine = 'checkindetermin',
    fieldfrom = 'from',
    fieldto = 'to',
    fieldduration = 'duration',
    dateonly = 'dateonly',
    timeonly = 'timeonly',
    record = 'record',
    owner = 'owner',
    defaulttablename = 'defaulttable',
    defaultfieldname = 'defaultfield',
    emptyevent = 'emptyevent',
    globalview = 'globalview',
    overdue = 'overdue',
    notavailable = 'notavailable',
    supportname = 'supportname',
    total = 'total',
    backup = 'backup',
    emptysheet = 'emptysheet',
    verifyemailtitle = 'verifyemailtitle',
    verifyemailtext = 'verifyemailtext',
    verifyemailsubmit = 'verifyemailsubmit',
    verifyphonetext = 'verifyphonetext',
    gdprallow = 'gdprallow',
    gdprdecline = 'gdprdecline',
    copy = 'copy',
    publicformnotification = 'publicformnotification'
}

export default Message;